import React, { useState } from 'react';
import { Button, Row, Col } from 'reactstrap';

const FirstActionStep = ({ onComplete, onBack }) => {
  const [selectedAction, setSelectedAction] = useState(null);

  const actions = [
    {
      id: 'automation',
      title: 'Crear tu primera automatización',
      description: 'Diseña un flujo de ventas completo. Claryo lo ejecutará automáticamente todos los días.',
      icon: 'mdi-automation',
      route: '/automation/workflows',
      color: '#E9553E'
    },
    {
      id: 'leads',
      title: 'Importar tus primeros leads',
      description: 'Sube tus contactos. Claryo comenzará a nutrirlos y gestionarlos automáticamente.',
      icon: 'mdi-account-plus',
      route: '/leads',
      color: '#28a745'
    },
    {
      id: 'campaign',
      title: 'Configurar tu primera campaña',
      description: 'Crea una campaña de email. Claryo la enviará y rastreará automáticamente.',
      icon: 'mdi-email-send',
      route: '/campaigns',
      color: '#007bff'
    }
  ];

  return (
    <div className="onboarding-step action-step-fullscreen">
      <Row className="justify-content-center">
        <Col lg={11} xl={10}>
          <div className="step-header-fullscreen mb-4">
            <Button 
              color="link" 
              className="back-btn"
              onClick={onBack}
            >
              <i className="mdi mdi-arrow-left"></i> Volver
            </Button>
            
            <h1 className="step-title-large mb-2">
              ¿Qué quieres que Claryo ejecute primero?
            </h1>
            <p className="step-description-large">
              Elige tu primera acción. Claryo se encargará de ejecutarla automáticamente.
            </p>
          </div>

          <Row className="g-3 mb-4">
            {actions.map(action => (
              <Col md={4} key={action.id}>
                <div 
                  className={`action-card-fullscreen ${selectedAction === action.id ? 'selected' : ''}`}
                  onClick={() => setSelectedAction(action.id)}
                  style={{
                    borderColor: selectedAction === action.id ? action.color : '#e9ecef'
                  }}
                >
                  <div 
                    className="action-icon-large"
                    style={{
                      backgroundColor: `${action.color}15`,
                      color: action.color
                    }}
                  >
                    <i className={`mdi ${action.icon}`}></i>
                  </div>
                  <h4 className="action-title">{action.title}</h4>
                  <p className="action-description">{action.description}</p>
                  {selectedAction === action.id && (
                    <div className="action-selected-badge">
                      <i className="mdi mdi-check-circle"></i>
                      Seleccionado
                    </div>
                  )}
                </div>
              </Col>
            ))}
          </Row>

          <div className="form-actions-fullscreen">
            <Button 
              color="primary" 
              size="lg"
              className="onboarding-primary-btn w-100"
              disabled={!selectedAction}
              onClick={() => {
                const action = actions.find(a => a.id === selectedAction);
                onComplete(action.route);
              }}
            >
              {selectedAction 
                ? `Comenzar con ${actions.find(a => a.id === selectedAction)?.title.toLowerCase()}`
                : 'Selecciona una opción para continuar'
              }
              <i className="mdi mdi-arrow-right ms-2"></i>
            </Button>
            
            <Button 
              color="link" 
              className="w-100 mt-3"
              onClick={() => onComplete('/dashboard')}
            >
              Ir al dashboard directamente
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default FirstActionStep;

